import { render, staticRenderFns } from "./newsthree.vue?vue&type=template&id=62b7d382&scoped=true"
var script = {}
import style0 from "./newsthree.vue?vue&type=style&index=0&id=62b7d382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b7d382",
  null
  
)

export default component.exports